import { uniqBy } from 'lodash';
import { useMemo, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { InstantSearch } from 'react-instantsearch-hooks';

import { trpc } from '../../config/trpc';
import { InputAutocomplete, InputProps } from './InputAutocomplete';

export const UserInput = ({ name, ...props }: InputProps) => {
  const form = useFormContext();
  const value = useWatch({
    control: form.control,
    name,
  });

  const [searchTerm, setSearchTerm] = useState('');
  const { data } = trpc.searchUsers.useQuery({
    filters: {},
    search: searchTerm,
  });

  const { data: existingUser } = trpc.getUser.useQuery({
    id: value,
  });

  const mergedData = useMemo(() => {
    const merged = [
      ...(data?.['users']?.map((user) => ({
        label: user.full_name ?? user.preferred_name,
        value: user.id,
      })) ?? []),
      ...(!!data && existingUser
        ? [
            {
              label: existingUser.full_name ?? existingUser.preferred_name,
              value: existingUser.id,
            },
          ]
        : []),
    ];
    return uniqBy(merged, (x) => x.value);
  }, [data, existingUser]);

  return (
    <InstantSearch
      searchClient={{
        search: async ([search]) => {
          if (searchTerm !== search.params.query) {
            setSearchTerm(search.params.query);
          }

          return {
            results: [
              {
                hits: mergedData,
              },
            ],
          };
        },
      }}
      // Fake
      indexName="users"
    >
      {/* this type is a lie to make ti happy */}
      <InputAutocomplete<{ label: string; value: string }>
        hitMap={(hits) => {
          return hits;
        }}
        name={name}
        {...props}
      />
    </InstantSearch>
  );
};
